﻿const texts = [

  {  // direct texts
    pagetitle: 'EVO - Guide de formation interactif',
    printmessage: "Il n'existe pas de version imprimable pour ce guide.",
    altlang: 'EN',
    modaltitle: "Guide de formation interactif",
    modalsubtitle: "Nouvel outil d'illustration - assurance vie et maladie grave",
    errormsg: "La largeur de votre écran n'est pas suffisante. Si vous utilisez un appareil mobile, veuillez passer en mode paysage."
  },
  {  // title attribute values
    // printdesc: 'Imprimer ce document',
    altlangtitle: 'Go to the english version'
  },
  {  // src attribute values
    modallogo: require('../images/IAGF_couleurs_85.jpg')
  }
];

const demoTexts = [
  {  // Assurance vie universelle
    productName: "Assurance vie universelle",
    productCode: 'ass-vie',
    slides: [
      {
        title: 'Comment accéder à EVO?',
        code: 'ass-vie-lancement',
        image: require('../images/FR_lancement.jpg'),
        infos: [
          {
            buttonPosition: [87, 26.7, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 27.8, 7.4, 5.4],
            content: "Cliquez sur <i>Lancer</i> pour accéder à EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Accueil',
        code: 'ass-vie-accueil',
        image: require('../images/FR_VU_accueil.jpg'),
        infos: [
          {
            buttonPosition: [5.5, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 29.2, 11, 6.5],
            content: "Consultez l’espace <i>Nouveautés</i> pour découvrir les dernières mises à jour de la plateforme EVO; optimisation des outils, ajouts de fonctionnalités et nouveaux produits seront présentés en détails sous cette section.",
            modals: [
              {
                code: 'vu_accueil_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_accueil_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [22.3, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 36.7, 97.3, 63],
            content: "<i>Créer une illustration</i> permet d’accéder aux familles de produits à illustrer. Une fois la famille sélectionnée, vous pouvez choisir une protection de base au centre de l’écran.",
            modals: []
          },
          {
            buttonPosition: [40, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [36, 29.2, 12.8, 6.5],
            content: "<i>Mes dossiers</i> permet de consulter et modifier les illustrations sauvegardées, incluant les illustrations effectuées à partir de la Suite Interface.",
            modals: [
              {
                code: 'vu_accueil_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_accueil_modal2.jpg') + '" style="max-width: 90%"></div><br>Vous pouvez rechercher une vente existante en inscrivant le nom du dossier, du contractant ou de l’assuré dans la barre de recherche. Notez que cette fonctionnalité s’applique également aux ventes en cours ou celles complétées.'
              }
            ]
          },
          {
            buttonPosition: [67.9, 18.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [59, 29.2, 21.1, 6.7],
            content: "Cliquez sur <i>Comparateur de primes maladie grave</i> afin d’afficher et de comparer sur un même écran les montants et les primes des polices d’assurance maladie grave. Il sera également possible d’y accéder en cours d’illustration dans le produit d’assurance maladie grave.",
            modals: [
              {
                code: 'vu_accueil_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/comparateur_modale.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [86.9, 18.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [80.2, 29.2, 18.3, 6.7],
            content: "<i>Demander un changement</i> permet de demander la modification d’un contrat en vigueur : informations du client, ajout de protections, avenants, etc.",
            modals: []
          },
          {
            buttonPosition: [80.4, 36.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [81.1, 30, 3, 4.7],
            content: "Le cadenas indique qu’une connexion est requise pour accéder à la section.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 77, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.6, 78.1, 23.9, 20],
            content: "Sélectionner la famille <i>Concepts</i> pour illustrer certains produits admissibles en montrant comment ils peuvent aider vos clients à atteindre leurs objectifs financiers en plus de répondre à leur besoin d'assurance.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Interface générale',
        code: 'ass-vie-interface-generale',
        image: require('../images/FR_VU_interface-generale.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -1.2, 101.3, 7.4],
            content: "À partir de cette page, vous pouvez en tout temps : <ul>" +
              "<li><img src=" + require('../images/icon-tool.jpg') + "> Transférer le dossier à une tierce personne </li>" +
              "<li><img src=" + require('../images/label-connection.jpg') + "> Établir une connexion sécurisée</li>" +
              "<li><img src=" + require('../images/icon-save.jpg') + "> Enregistrer votre illustration et activer la sauvegarde automatique.</li>" +
              "<li><img src=" + require('../images/icon-suitcase.jpg') + "> Exigences – Assurance vie / Assurance maladie grave.</li>" +
              "<li><img src=" + require('../images/icon-home.jpg') + "> Retourner à l’écran d’accueil des familles de produits</li>" +
              "<li><img src=" + require('../images/icon-settings.jpg') + "> Personnaliser votre profil et vos paramètres par défaut</li>" +
              "<li><img src=" + require('../images/icon-help.jpg') + "> Obtenir de l’information sur le logiciel</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 8.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.8, 49.9, 5.7],
            content: "Cette section permet la création d’un nouveau scénario ou d’en dupliquer un afin d’illustrer des alternatives pour votre client ou des membres de sa famille, jusqu'à un maximum de cinq scénarios. Il est également possible de réinitialiser les scénarios.",
            modals: []
          },
          {
            buttonPosition: [79.4, 9.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2, 11.6, 76, 6],
            content: "<b><u>Protections</u> : </b>permet d’afficher le type de protection sélectionnée, d’identifier les assurés et les contractants, de sélectionner des protections supplémentaires et des avenants et de simuler une prime en fonction des dépôts et des retraits projetés.<br><br>" +
              "<b><u>Profil d'investisseur</u> : </b>permet de remplir le formulaire afin d’établir le profil d’investisseur. <br><br>" +
              "<b><u>Investissements</u> : </b>permet d’indiquer les choix de fonds distincts dans le compte portefeuille de la police de votre client. <br><br>" +
              "<b><u>Concepts</u> : </b>permet d'activer et de paramétrer un concept de vente sur l'illustration en cours ou encore de le désactiver.<br><br>" +
              "<b><u>Résultats</u> : </b>permet de consulter les tableaux de résultats des projections du scénario en cours.<br><br>" +
              "<b><u>Rapports</u> : </b>permet de générer et d'imprimer le rapport d’illustration.",
            modals: []
          },
          {
            buttonPosition: ['auto', 49, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 17.6, 79.1, 82],
            content: "Cette section permet d’entrer les informations de l’illustration rapidement afin d’obtenir une prime instantanément.",
            modals: []
          },
          {
            buttonPosition: [72.6, 83, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.2, 17.6, 20.5, 82],
            content: "<b><u>Au contrat</u> : </b>présente la prime versée pour le contrat de votre client ainsi que la prime de référence et maximale.<br><br>" +
              "<b><u>Détails des protections</u> : </b>présente toutes les protections de tous les assurés du scénario en cours.<br><br>" +
              "<b><u>Passer à la proposition</u> : </b>si l’un des crochets est gris, vous devrez ajouter les informations manquantes pour passer à la proposition.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Protections (Assurés et protections)',
        code: 'ass-vie-ecran-principale-protection',
        image: require('../images/FR_VU_protection-assures.jpg'),
        infos: [
          {
            buttonPosition: [59.7, 11.3, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.4, 13.6, 56.1, 4.3],
            content: "Vous pouvez sélectionner le type d’assurance (individuelle ou conjointe) du scénario afin d’avoir une illustration cohérente avec les besoins de votre client.",
            modals: []
          },
          {
            buttonPosition: ['auto', 20.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.8, 23.2, 15.9, 4.5],
            content: "Cliquez sur le crayon afin d’inscrire le nom et le prénom de l’assuré.",
            modals: [
              {
                code: 'vu_protection-assures_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-assures_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 15, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [76.4, 18.2, 18.3, 3.7],
            content: "Ce lien cliquable permet de démontrer l’effet d’un statut préférentiel d’un des assurés.",
            modals: [
              {
                code: 'vu_protection-assures_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-assures_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 32, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [82.9, 36.2, 12.3, 3.9],
            content: "Ce lien cliquable permet d’ajouter une surprime sur une protection pour un assuré.",
            modals: [
              {
                code: 'vu_protection-assures_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-assures_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 34, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.2, 41.7, 57.2, 4.6],
            content: "Sélectionner la prestation de décès Capital + fonds avec option valeur maximisée afin d’optimiser les investissements de vos clients tout en maintenant les coûts d’assurance aussi bas que possible. Référez-vous au Guide interactif pour en savoir plus sur l’illustration du Capital + fonds avec option de valeur maximisée. Seulement disponible pour le produit TRA.",
            modals: []
          },
          {
            buttonPosition: [102, 46, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.4, 47.1, 95.3, 10.3],
            content: "Vous pouvez modifier la protection de base du scénario. Cette section présente les options supplémentaires disponibles en fonction de la protection de base sélectionnée.",
            modals: []
          },
          {
            buttonPosition: [72, 58, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [61, 47.4, 31.1, 10.2],
            content: "Cliquer sur la touche <i>Prime</i> afin de déterminer le montant du capital assuré en fonction d’une prime donnée qui correspond au budget du client. Vous pourrez inscrire le montant de la prime et le capital assuré s’affichera automatiquement. Il est également possible de basculer vers la touche <i>Montant</i> et inscrire ensuite le montant d’assurance pour obtenir la prime correspondante. Vous pouvez illustrer des protections d’assurance qui excèdent les limites de certains produits, jusqu’à 90M$.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45.9, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.6, 51.8, 4.3, 5.6],
            content: "Cliquer sur l’icône document afin d’accéder au <i>Guide du produit</i>.",
            modals: []
          },
          {
            buttonPosition: ['auto', 57.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.2, 58, 31, 4.3],
            content: "Cliquez sur <i>Ajouter une protection/avenant</i> pour ajouter une protection additionnelle ou une garantie.",
            modals: [
              {
                code: 'vu_protection-assures_modal6',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-assures_modal6.jpg') + '" style="max-width: 90%"></div><br>Ce panneau permet de faire les choix de protections supplémentaires selon les besoins de votre client.'
              }
            ]
          },
          {
            buttonPosition: ['auto', 73.2, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [1.5, 69, 97.5, 30.5],
            content: "Vous pouvez ajouter un contractant supplémentaire ou le remplacer par une société. Cliquez sur le crayon pour le modifier au besoin.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: 'Protections (Informations générales, Prime versée, Investissements)',
        code: 'ass-vie-ecran-principale-info',
        image: require('../images/FR_VU_protection-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 5, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 7, 84.1, 4.1],
            content: "Sélectionnez la province de résidence du contractant.",
            modals: []
          },
          {
            buttonPosition: [104, 10.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 12.4, 66.5, 3.8],
            content: "Le taux d’imposition de la province sélectionnée est affiché par défaut : celui-ci peut être modifié. Cliquez sur <i>Autres taux</i> pour connaître les différents types de taux et gérer les taux relatifs aux sociétés.",
            modals: [
              {
                code: 'vu_protection-info_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 14.7, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 16.9, 76.4, 3.7],
            content: "Cliquez sur <i>Modifier</i> pour modifier la date d'effet du contrat. Pour en savoir plus sur la date d'effet, cliquez sur <i>Modifier</i> et ensuite sur le point d’interrogation dans le coin supérieur droit.",
            modals: [
              {
                code: 'vu_protection-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 26.8, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 29.1, 95.4, 3.9],
            content: "Choisissiez la fréquence du paiement de la prime. La sélection affectera les montants affichés dans le sommaire.",
            modals: []
          },
          {
            buttonPosition: [103, 37, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 33.3, 95.4, 17.3],
            content: "Sélectionnez le type de prime et effectuez une optimisation de la prime, si désiré, selon les objectifs du client.",
            modals: []
          },
          {
            buttonPosition: ['auto', 55.9, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 58, 47.3, 3.9],
            content: "Vous pouvez modifier le taux d’intérêt composé basé sur le rendement que vous souhaitez illustrer.",
            modals: []
          },
          {
            buttonPosition: ['auto', 76.8, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 78.6, 71.4, 4.5],
            content: "Gérez les dépôts forfaitaires et les retraits relatifs au scénario illustré en cliquant sur les liens respectifs. Ces montants seront reflétés dans le tableau des résultats.",
            modals: [
              {
                code: 'vu_protection-info_modal7',
                content: '<div class="ui container" style="display: flex;flex-flow: row wrap;justify-content: space-around;"><img src="' + require('../images/FR_VU_protection-info_modal7-1.jpg') + '" style="max-width: 90%"><img src="' + require('../images/FR_VU_protection-info_modal7-2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
        ],
        modals: []
      },
      {
        title: "Profil d'investisseur",
        code: 'ass-vie-ecran-principale-profil',
        image: require('../images/FR_VU_profil.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 15, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 18.8, 15, 4.1],
            content: "Cette section présente le nom du ou des contractants, qu’il soit un assuré, un individu ou une société.",
            modals: []
          },
          {
            buttonPosition: ['auto', 53.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 22.9, 19.6, 76.8],
            content: "Cette section indique l’avancement du questionnaire du profil d’investisseur.",
            modals: []
          },
          {
            buttonPosition: [72.6, 16.7, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [20.5, 22.9, 57.9, 76.8],
            content: "Remplissez ce questionnaire interactif avec votre client afin de dresser son profil d’investisseur. Une fois toutes les questions complétées, le résultat sera présenté sous forme de graphique afin de faciliter la compréhension du portrait du client.",
            modals: [
              {
                code: 'vu_profil_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_profil_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
        ],
        modals: []
      },
      {
        title: "Investissements",
        code: 'ass-vie-ecran-principale-investissements',
        image: require('../images/FR_VU_investissements.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 36, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 38.5, 20.7, 4.5],
            content: "Ce bouton permet d’accéder à la liste des comptes d’investissement disponibles sélectionnés.",
            modals: [
              {
                code: 'vu_investissements_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_investissements_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [36.9, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [42.7, 23.2, 11.7, 4],
            content: "Cochez cette case si vous souhaitez que les directives de déduction automatique (DDA) soient identiques aux directives d’investissement automatique (DIA).",
            modals: []
          },
          {
            buttonPosition: [51.1, 30.7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [37.2, 33.1, 12.5, 3.6],
            content: "Indiquez le pourcentage souhaité dans les encadrés pour identifier la composition du DIA/DDA.",
            modals: []
          },
          {
            buttonPosition: [71.1, 14.9, 'auto'],
            popupPosition: ['top', 'center'],
            pointerPosition: [67.5, 23.9, 7.3, 3.4],
            content: "Cliquer sur <i>Personnaliser</i> afin d’effectuer une projection en personnalisant le taux d’intérêt anticipé des comptes d’investissement des fonds de capitalisation individuellement sur une base annuelle ou sur un nombre d’années adapté à la situation de l’assuré.",
            modals: [
              {
                code: 'vu_investissements_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_investissements_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          }
        ],
        modals: []
      },
      {
        title: "Concepts",
        code: 'ass-vie-ecran-concepts',
        image: require('../images/FR_VU_concepts.jpg'),
        infos: [
          {
            buttonPosition: [29.5, 21.1, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 22.8, 27.1, 5.0],
            content: "La liste déroulante permet de sélectionner le concept à présenter.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 29.1, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.5, 29.1, 54, 35.8],
            content: "Vous pouvez modifier les différents paramètres qui seront appliqués au concept.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Résultats",
        code: 'ass-vie-ecran-principale-resultats',
        image: require('../images/FR_VU_resultats.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 20, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 22.2, 22.2, 3.9],
            content: "La liste déroulante permet de sélectionner le type de tableau à présenter.",
            modals: []
          },
          {
            buttonPosition: [35, 20.2, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [24, 22.2, 10.2, 3.9],
            content: "Cliquez sur ce lien pour voir la liste des assurés du scénario.",
            modals: [
              {
                code: 'vu_resultats_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_resultats_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [57.9, 17.3, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64, 18.4, 14.8, 7.2],
            content: "Cliquez sur ce bouton pour exporter le tableau de résultats dans un document Excel.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Rapports",
        code: 'ass-vie-ecran-principale-rapports',
        image: require('../images/FR_VU_rapports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 38, 49.6, 48],
            content: "Sélectionnez les informations que vous souhaitez inclure dans votre rapport.",
            modals: []
          },
          {
            buttonPosition: [66, 79, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 81, 14.4, 5.5],
            content: "Ajoutez le nom du conseiller afin de personnaliser le rapport.",
            modals: [
              {
                code: 'vu_rapports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_rapports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },

          {
            buttonPosition: [45, 31, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 32.3, 14, 5.5],
            content: "Sélectionnez la langue dans laquelle vous souhaitez générer le rapport.",
            modals: []
          },
          {
            buttonPosition: [58.1, 18.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.5, 18.5, 15.8, 9],
            content: "Générez le rapport personnalisé en format PDF en cliquant sur ce bouton.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
  {  // Assurance traditionnelle
    productName: "Assurance traditionnelle",
    productCode: 'ass-trad',
    slides: [
      {
        title: 'Comment accéder à EVO?',
        code: 'ass-trad-lancement',
        image: require('../images/FR_lancement.jpg'),
        infos: [
          {
            buttonPosition: [87, 26.7, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 27.8, 7.4, 5.4],
            content: "Cliquez sur <i>Lancer</i> pour accéder à EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Accueil',
        code: 'ass-trad-accueil',
        image: require('../images/FR_TR_accueil.jpg'),
        infos: [
          {
            buttonPosition: [5.5, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 29.2, 11, 6.5],
            content: "Consultez l’espace <i>Nouveautés</i> pour découvrir les dernières mises à jour de la plateforme EVO; optimisation des outils, ajouts de fonctionnalités et nouveaux produits seront présentés en détails sous cette section.",
            modals: [
              {
                code: 'tr_accueil_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_accueil_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [22.3, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 36.7, 97.3, 63],
            content: "<i>Créer une illustration</i> permet d’accéder aux familles de produits à illustrer. Une fois la famille sélectionnée, vous pouvez choisir une protection de base au centre de l’écran.",
            modals: []
          },
          {
            buttonPosition: [40, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [36, 29.2, 12.8, 6.5],
            content: "<i>Mes dossiers</i> permet de consulter et modifier les illustrations sauvegardées, incluant les illustrations effectuées à partir de la Suite Interface.",
            modals: [
              {
                code: 'tr_accueil_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_accueil_modal2.jpg') + '" style="max-width: 90%"></div><br>Vous pouvez rechercher une vente existante en inscrivant le nom du dossier, du contractant ou de l’assuré dans la barre de recherche. Notez que cette fonctionnalité s’applique également aux ventes en cours ou celles complétées.'
              }
            ]
          },
          {
            buttonPosition: [67.9, 18.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [59, 29.2, 21.1, 6.7],
            content: "Cliquez sur <i>Comparateur de primes maladie grave</i> afin d’afficher et de comparer sur un même écran les montants et les primes des polices d’assurance maladie grave. Il sera également possible d’y accéder en cours d’illustration dans le produit d’assurance maladie grave.",
            modals: [
              {
                code: 'tr_accueil_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/comparateur_modale.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [86.9, 18.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [80.2, 29.2, 18.3, 6.7],
            content: "<i>Demander un changement</i> permet de demander la modification d’un contrat en vigueur : informations du client, ajout de protections, avenants, etc.",
            modals: []
          },
          {
            buttonPosition: [80.4, 36.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [81.1, 30, 3, 4.7],
            content: "Le cadenas indique qu’une connexion est requise pour accéder à la section.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Interface générale',
        code: 'ass-trad-interface-generale',
        image: require('../images/FR_TR_interface-generale.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -1.2, 101.3, 7.4],
            content: "À partir de cette page, vous pouvez en tout temps : <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transférer le dossier à une tierce personne </li>" +
              "<li><img src='" + require('../images/label-connection.jpg') + "'> Établir une connexion sécurisée</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Enregistrer votre illustration et activer la sauvegarde automatique.</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Exigences – Assurance vie / Assurance maladie grave.</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Retourner à l’écran d’accueil des familles de produits</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Personnaliser votre profil et vos paramètres par défaut</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Obtenir de l’information sur le logiciel</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 8.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.8, 50.1, 5],
            content: "Cette section permet la création d’un nouveau scénario ou d’en dupliquer un afin d’illustrer des alternatives pour votre client ou des membres de sa famille, jusqu'à un maximum de cinq scénarios. Il est également possible de réinitialiser les scénarios.",
            modals: []
          },
          {
            buttonPosition: [37.9, 9.9, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [2, 11.6, 33.9, 4.8],
            content: "<b><u>Protections</u> : </b>permet d’afficher le type de protection sélectionnée, d’identifier les assurés et les contractants, de sélectionner des protections supplémentaires et des avenants et de simuler une prime en fonction des dépôts et des retraits projetés.<br><br>" +
              "<b><u>Résultats</u> : </b>permet de consulter les tableaux de résultats des projections du scénario en cours.<br><br>" +
              "<b><u>Rapports</u> : </b>permet de générer et d'imprimer le rapport d’illustration.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 16.3, 79.1, 79],
            content: "Cette section permet d’entrer les informations de l’illustration rapidement afin d’obtenir une prime instantanément.",
            modals: []
          },
          {
            buttonPosition: [73.6, 90, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.2, 16.3, 20.5, 83.3],
            content: "<b><u>Au contrat</u> : </b>présente la prime versée pour le contrat de votre client.<br><br>" +
              "<b><u>Détails des protections</u> : </b>présente toutes les protections de tous les assurés du scénario en cours ainsi que les frais de police.<br><br>" +
              "<b><u>Passer à la proposition</u> : </b>si l’un des crochets est gris, vous devrez ajouter les informations manquantes pour passer à la proposition.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Protections (Assurés et protections)',
        code: 'ass-trad-ecran-principale-protection',
        image: require('../images/FR_TR_protection-assures.jpg'),
        infos: [
          {
            buttonPosition: [61.5, 9, 'auto'],
            popupPosition: ['top', 'center'],
            pointerPosition: [1.3, 11.9, 56.4, 3.7],
            content: "Vous pouvez sélectionner le type d’assurance (individuelle ou conjointe) du scénario afin d’avoir une illustration cohérente avec les besoins de votre client.",
            modals: []
          },
          {
            buttonPosition: [102, 13, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [76.6, 15.8, 18.3, 3.5],
            content: "Ce lien cliquable permet de démontrer l’effet d’un statut préférentiel d’un des assurés.",
            modals: [
              {
                code: 'tr_protection-assures_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_protection-assures_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [42, 18, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [18.6, 20.8, 22.3, 4.2],
            content: "Il est possible d’ajouter des assurés additionnels: Vous devez choisir la protection de base pour chaque assuré supplémentaire.",
            modals: []
          },
          {
            buttonPosition: ['auto', 23.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.7, 26.5, 15.3, 3.9],
            content: "Cliquez sur le crayon afin d’inscrire le nom et le prénom de l’assuré.",
            modals: [
              {
                code: 'tr_protection-assures_modal2',
                content: '<div class="ui container center aligned"><img src=" ' + require('../images/FR_TR_protection-assures_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 34, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [83.2, 37.5, 12.3, 3.9],
            content: "Ce lien cliquable permet d’ajouter une surprime sur une protection pour un assuré.",
            modals: [
              {
                code: 'tr_protection-assures_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_protection-assures_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 37, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 42.6, 95.5, 9.4],
            content: "Vous pouvez modifier la protection de base du scénario. Cette section présente les options supplémentaires disponibles en fonction de la protection de base sélectionnée.",
            modals: []
          },
          {
            buttonPosition: ['auto', 48, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 46.5, 3.8, 5.4],
            content: "Cliquer sur l’icône document afin d’accéder au <i>Guide du produit</i>.",
            modals: []
          },
          {
            buttonPosition: [51, 44.2, 'auto'],
            popupPosition: ['top', 'center'],
            pointerPosition: [2.8, 52.2, 47, 5],
            content: "Inscrivez la durée de projection souhaitée par le contractant selon ses besoins pour chaque protection temporaire sélectionnée. Notez que les valeurs minimales et le maximales permises vous sont indiquées et que la valeur par défaut sera la durée maximale disponible pour la protection.",
            modals: []
          },
          {
            buttonPosition: [102, 46, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [61.1, 42.6, 30.8, 9.3],
            content: "Cliquer sur la touche <i>Prime</i> afin de déterminer le montant du capital assuré en fonction d’une prime donnée qui correspond au budget du client. Vous pourrez inscrire le montant de la prime et le capital assuré s’affichera automatiquement. Il est également possible de basculer vers la touche <i>Montant</i> et inscrire ensuite le montant d’assurance pour obtenir la prime correspondante. Vous pouvez illustrer des protections d’assurance qui excèdent les limites de certains produits, jusqu’à 90M$.",
            modals: []
          },
          {
            buttonPosition: [37.6, 58.7, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [2.8, 57, 33.1, 4.6],
            content: "Cliquez sur <i>Ajouter une protection/avenant</i> pour ajouter une protection additionnelle ou une garantie.",
            modals: [
              {
                code: 'tr_protection-assures_modal6',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_protection-assures_modal6.jpg') + '" style="max-width: 90%"></div><br>Ce panneau permet de faire les choix de protections supplémentaires selon les besoins de votre client.'
              }
            ]
          },
          {
            buttonPosition: [102, 74.2, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.7, 72.4, 97.2, 26.3],
            content: "Vous pouvez ajouter un contractant supplémentaire ou le remplacer par une société. Cliquez sur le crayon pour le modifier au besoin.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Protections (Informations générale, Prime versée)',
        code: 'ass-trad-ecran-principale-info',
        image: require('../images/FR_TR_protection-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 10, 103],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 12.7, 83.8, 7.2],
            content: "Sélectionnez la province de résidence du contractant.",
            modals: []
          },
          {
            buttonPosition: [104, 20.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 22.3, 65.9, 7.2],
            content: "Le taux d’imposition de la province sélectionnée est affiché par défaut : celui-ci peut être modifié. Cliquez sur <i>Autres taux</i> pour connaître les différents types de taux et gérer les taux relatifs aux sociétés.",
            modals: [
              {
                code: 'tr_protection-info_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 28, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 30.9, 74.4, 5.7],
            content: "Cliquez sur <i>Modifier</i> pour modifier la date d'effet du contrat. Pour en savoir plus sur la date d'effet, cliquez sur <i>Modifier</i> et ensuite sur le point d’interrogation dans le coin supérieur droit.",
            modals: [
              {
                code: 'tr_protection-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_protection-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 49.6, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 50.7, 93.4, 8.9],
            content: "Choisissiez la fréquence du paiement de la prime. La sélection affectera les montants affichés dans le sommaire.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Résultats",
        code: 'ass-trad-ecran-principale-resultats',
        image: require('../images/FR_TR_resultats.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 18, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 20, 16.1, 3.91],
            content: "La liste déroulante permet de sélectionner le type de tableau à présenter.",
            modals: []
          },
          {
            buttonPosition: [29.4, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [17.6, 20, 10.2, 3.91],
            content: "Cliquez sur ce lien pour voir la liste des assurés du scénario.",
            modals: [
              {
                code: 'tr_resultats_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_resultats_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [58.1, 16.1, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64, 17, 14.8, 6.4],
            content: "Cliquez sur ce bouton pour exporter le tableau de résultats dans un document Excel.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Rapports",
        code: 'ass-trad-ecran-principale-rapports',
        image: require('../images/FR_TR_rapports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 38, 49.6, 22],
            content: "Sélectionnez les informations que vous souhaitez inclure dans votre rapport.",
            modals: []
          },
          {
            buttonPosition: [66, 79, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 81, 14.4, 5.5],
            content: "Ajoutez le nom du conseiller afin de personnaliser le rapport.",
            modals: [
              {
                code: 'tr_rapports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_rapports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },

          {
            buttonPosition: [45, 31, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 31.8, 14, 5.5],
            content: "Sélectionnez la langue dans laquelle vous souhaitez générer le rapport.",
            modals: []
          },
          {
            buttonPosition: [58.1, 18.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.5, 18.5, 15.8, 9],
            content: "Générez le rapport personnalisé en format PDF en cliquant sur ce bouton.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
  {  // Assurance maladie grave
    productName: "Assurance maladie grave",
    productCode: 'ass-mal',
    slides: [
      {
        title: 'Comment accéder à EVO?',
        code: 'ass-mal-lancement',
        image: require('../images/FR_lancement.jpg'),
        infos: [
          {
            buttonPosition: [87, 26.7, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 27.8, 7.4, 5.4],
            content: "Cliquez sur <i>Lancer</i> pour accéder à EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Accueil',
        code: 'ass-mal-accueil',
        image: require('../images/FR_MG_accueil.jpg'),
        infos: [
          {
            buttonPosition: [5.5, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 29.2, 11, 6.5],
            content: "Consultez l’espace <i>Nouveautés</i> pour découvrir les dernières mises à jour de la plateforme EVO; optimisation des outils, ajouts de fonctionnalités et nouveaux produits seront présentés en détails sous cette section.",
            modals: [
              {
                code: 'mg_accueil_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_accueil_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [22.3, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 36.7, 97.3, 63],
            content: "<i>Créer une illustration</i> permet d’accéder aux familles de produits à illustrer. Une fois la famille sélectionnée, vous pouvez choisir une protection de base au centre de l’écran.",
            modals: []
          },
          {
            buttonPosition: [40, 20.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [36, 29.2, 12.8, 6.5],
            content: "<i>Mes dossiers</i> permet de consulter et modifier les illustrations sauvegardées, incluant les illustrations effectuées à partir de la Suite Interface.",
            modals: [
              {
                code: 'mg_accueil_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_accueil_modal2.jpg') + '" style="max-width: 90%"></div><br>Vous pouvez rechercher une vente existante en inscrivant le nom du dossier, du contractant ou de l’assuré dans la barre de recherche. Notez que cette fonctionnalité s’applique également aux ventes en cours ou celles complétées.'
              }
            ]
          },
          {
            buttonPosition: [67.9, 18.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [59, 29.2, 21.1, 6.7],
            content: "Cliquez sur <i>Comparateur de primes maladie grave</i> afin d’afficher et de comparer sur un même écran les montants et les primes des polices d’assurance maladie grave. Il sera également possible d’y accéder en cours d’illustration dans le produit d’assurance maladie grave. Passez au prochain écran pour connaitre les détails de cette fonctionnalité",
            modals: []
          },
          {
            buttonPosition: [86.9, 18.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [80.2, 29.2, 18.3, 6.7],
            content: "<i>Demander un changement</i> permet de demander la modification d’un contrat en vigueur : informations du client, ajout de protections, avenants, etc.",
            modals: []
          },
          {
            buttonPosition: [80.4, 36.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [81.1, 30, 3, 4.7],
            content: "Le cadenas indique qu’une connexion est requise pour accéder à la section.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Comparateur de primes maladie grave',
        code: 'ass-mal-comparateur-primes',
        image: require('../images/FR_MG_comparateur.jpg'),
        infos: [
          {
            buttonPosition: [-3.3, 27.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [4.8, 25.5, 22.65, 12.7],
            content: "Inscrivez les informations de l’assuré afin d’obtenir les primes de bases et les primes totales dans la section <i>Protection</i> de droite.",
            modals: []
          },
          {
            buttonPosition: [-3.3, 47.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [4.2, 44.5, 23.65, 14.9],
            content: "Cliquer sur la touche <i>Prime</i> afin de déterminer le montant du capital assuré en fonction d’une prime donnée qui correspond au budget du client. Vous pourrez inscrire le montant de la prime et le capital assuré s’affichera automatiquement. Il est également possible de basculer vers la touche Montant et inscrire ensuite le montant d’assurance pour obtenir la prime correspondante. Vous pouvez également choisir la fréquence du paiement de la prime.",
            modals: []
          },
          {
            buttonPosition: [-3.3, 66.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [4.2, 63.5, 23.65, 15.4],
            content: "Sélectionnez un des avenants ci-dessous selon les besoins de l’assuré.",
            modals: []
          },
          {
            buttonPosition: [85.7, 10.5, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [29.1, 25.2, 66.15, 58.9],
            content: "Cette section met à jour les montants des primes de base, des primes totales et du capital assuré en fonction des sélections effectuées dans la section de gauche. Sélectionnez la protection souhaitée pour la mettre en évidence.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Interface générale',
        code: 'ass-mal-interface-generale',
        image: require('../images/FR_MG_interface-generale.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -0.5, 101.3, 5.7],
            content: "À partir de cette page, vous pouvez en tout temps : <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transférer le dossier à une tierce personne </li>" +
              "<li><img src='" + require('../images/label-connection.jpg') + "'> Établir une connexion sécurisée</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Enregistrer votre illustration et activer la sauvegarde automatique.</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Exigences – Assurance vie / Assurance maladie grave.</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Retourner à l’écran d’accueil des familles de produits</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Personnaliser votre profil et vos paramètres par défaut</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Obtenir de l’information sur le logiciel</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 7.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.4, 50.7, 5],
            content: "Cette section permet la création d’un nouveau scénario ou d’en dupliquer un afin d’illustrer des alternatives pour votre client ou des membres de sa famille, jusqu'à un maximum de cinq scénarios. Il est également possible de réinitialiser les scénarios.",
            modals: []
          },
          {
            buttonPosition: [37.9, 9.9, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [2, 11, 33.9, 4.8],
            content: "<b><u>Protections</u> : </b>permet d’afficher le type de protection sélectionnée, d’identifier les assurés et les contractants, de sélectionner des protections supplémentaires et des avenants et de simuler une prime en fonction des dépôts et des retraits projetés.<br><br>" +
              "<b><u>Résultats</u> : </b>permet de consulter les tableaux de résultats des projections du scénario en cours.<br><br>" +
              "<b><u>Rapports</u> : </b>permet de générer et d'imprimer le rapport d’illustration.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 15.7, 79.1, 83.8],
            content: "Cette section permet d’entrer les informations de l’illustration rapidement afin d’obtenir une prime instantanément.",
            modals: []
          },
          {
            buttonPosition: [73.6, 46, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.2, 15.7, 20.5, 83.6],
            content: "<b><u>Au contrat</u> : </b>présente la prime versée pour le contrat de votre client.<br><br>" +
              "<b><u>Détails des protections</u> : </b>présente toutes les protections de tous les assurés du scénario en cours ainsi que les frais de police. Il se met à jour automatiquement lors de chaque modification de protection.<br><br>" +
              "<b><u>Passer à la proposition</u> : </b>si l’un des crochets est gris, vous devrez ajouter les informations manquantes pour passer à la proposition.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Protections (Assurés et protections)',
        code: 'ass-mal-ecran-principale-protection',
        image: require('../images/FR_MG_protection-assures.jpg'),
        infos: [
          {
            buttonPosition: [32.5, 9, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [1.3, 11, 29.3, 4.4],
            content: "Vous pouvez visualiser le type d'assurance à cet endroit, mais celui-ci n'est pas modifiable pour ce type de protection de base au contrat.",
            modals: []
          },
          {
            buttonPosition: [43, 17, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [18.6, 20, 22.3, 3.5],
            content: "Il est possible d’ajouter des assurés additionnels: Vous devez choisir la protection de base pour chaque assuré supplémentaire.",
            modals: []
          },
          {
            buttonPosition: ['auto', 22.2, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.7, 25, 15.3, 3.8],
            content: "Cliquez sur le crayon afin d’inscrire le nom et le prénom de l’assuré.",
            modals: [
              {
                code: 'mg_protection-assures_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_protection-assures_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [48, 32.9, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [61.5, 35.7, 21.9, 3.9],
            content: "Cliquez sur <i>Comparateur de primes</i> afin d’afficher et de comparer sur un même écran les montants et les primes des polices d’assurance maladie grave. Vous pourrez entre autres indiquer les informations de l’assuré, le montant de prime ou le montant du capital assuré pour cette protection. Cliquez sur <i>Appliquer</i> pour ajouter la protection.",
            modals: [
              {
                code: 'mg_protection-assures_modal10',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_protection-assures_modal10.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 32.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [83, 35.7, 12.3, 3.9],
            content: "Ce lien cliquable permet d’ajouter une surprime sur une protection pour un assuré.",
            modals: [
              {
                code: 'mg_protection-assures_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_protection-assures_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 40.6, 95.3, 8.9],
            content: "Vous pouvez modifier la protection de base du scénario. Cette section présente les options supplémentaires disponibles en fonction de la protection de base sélectionnée.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.9, 44.5, 4.3, 5.1],
            content: "Cliquer sur l’icône document afin d’accéder au <i>Guide du produit.</i>",
            modals: []
          },
          {
            buttonPosition: [51, 50.9, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [2.8, 49.8, 47.2, 4.5],
            content: "Inscrivez la durée de projection souhaitée par le contractant selon ses besoins pour chaque protection temporaire sélectionnée. Notez que les valeurs minimales et le maximales permises vous sont indiquées et que la valeur par défaut sera la durée maximale disponible pour la protection.",
            modals: []
          },
          {
            buttonPosition: [71, 50, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [61.5, 40.8, 30.6, 8.7],
            content: "Cliquer sur la touche <i>Prime</i> afin de déterminer le montant du capital assuré en fonction d’une prime donnée qui correspond au budget du client. Vous pourrez inscrire le montant de la prime et le capital assuré s’affichera automatiquement. Il est également possible de basculer vers la touche <i>Montant</i> et inscrire ensuite le montant d’assurance pour obtenir la prime correspondante. Vous pouvez illustrer des protections d’assurance qui excèdent les limites de certains produits, jusqu’à 90M$.",
            modals: []
          },
          {
            buttonPosition: [38.6, 62, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [2.6, 60.7, 34.3, 3.3],
            content: "Cliquez sur <i>Ajouter une protection/avenant</i> pour ajouter une protection additionnelle ou une garantie.",
            modals: [
              {
                code: 'mg_protection-assures_modal7',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_protection-assures_modal7.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 74.2, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.7, 74.4, 97.2, 24.9],
            content: "Vous pouvez ajouter un contractant supplémentaire ou le remplacer par une société. Cliquez sur le crayon pour le modifier au besoin.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Protections (Informations générale, Prime versée)',
        code: 'ass-mal-ecran-principale-info',
        image: require('../images/FR_MG_protection-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 10, 103],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 12.7, 83.9, 7.2],
            content: "Sélectionnez la province de résidence du contractant.",
            modals: []
          },
          {
            buttonPosition: [104, 20.4, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [2.5, 22.3, 65.9, 7.2],
            content: "Le taux d’imposition de la province sélectionnée est affiché par défaut : celui-ci peut être modifié. Cliquez sur <i>Autres taux</i> pour connaître les différents types de taux et gérer les taux relatifs aux sociétés.",
            modals: [
              {
                code: 'mg_protection-info_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 28, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 30.9, 74.4, 5.7],
            content: "Cliquez sur <i>Modifier</i> pour modifier la date d'effet du contrat. Pour en savoir plus sur la date d'effet, cliquez sur <i>Modifier</i> et ensuite sur le point d’interrogation dans le coin supérieur droit.",
            modals: [
              {
                code: 'mg_protection-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_protection-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 49.6, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 51.1, 93.4, 8.9],
            content: "Choisissiez la fréquence du paiement de la prime. La sélection affectera les montants affichés dans le sommaire.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Résultats",
        code: 'ass-mal-ecran-principale-resultats',
        image: require('../images/FR_MG_resultats.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 18, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.7, 20, 16.1, 3.91],
            content: "La liste déroulante permet de sélectionner le type de tableau à présenter.",
            modals: []
          },
          {
            buttonPosition: [29.4, 18, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [17.6, 20, 10.2, 3.91],
            content: "Cliquez sur ce lien pour voir la liste des assurés du scénario.",
            modals: [
              {
                code: 'mg_resultats_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_resultats_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [58.1, 16.1, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64, 17, 14.8, 6.4],
            content: "Cliquez sur ce bouton pour exporter le tableau de résultats dans un document Excel.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Rapports",
        code: 'ass-mal-ecran-principale-rapports',
        image: require('../images/FR_MG_rapports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 35, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 38, 49.6, 26],
            content: "Sélectionnez les informations que vous souhaitez inclure dans votre rapport.",
            modals: []
          },
          {
            buttonPosition: [66, 79, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 81, 14.4, 5.5],
            content: "Ajoutez le nom du conseiller afin de personnaliser le rapport.",
            modals: [
              {
                code: 'mg_rapports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_MG_rapports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },

          {
            buttonPosition: [45, 31, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 32.2, 14, 5.5],
            content: "Sélectionnez la langue dans laquelle vous souhaitez générer le rapport.",
            modals: []
          },
          {
            buttonPosition: [58.1, 18.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.5, 18.5, 15.8, 9],
            content: "Générez le rapport personnalisé en format PDF en cliquant sur ce bouton.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
  {  // Assurance vie avec participation
    productName: "Assurance vie avec participation",
    productCode: 'ass-par',
    slides: [
      {
        title: 'Comment accéder à EVO?',
        code: 'ass-par-lancement',
        image: require('../images/FR_lancement.jpg'),
        infos: [
          {
            buttonPosition: [87, 26.7, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [92.3, 27.8, 7.4, 5.4],
            content: "Cliquez sur <i>Lancer</i> pour accéder à EVO.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Accueil',
        code: 'ass-par-accueil',
        image: require('../images/FR_PAR_accueil.jpg'),
        infos: [
          {
            buttonPosition: [5.5, 19.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.9, 28.2, 11, 6.5],
            content: "Consultez l’espace <i>Nouveautés</i> pour découvrir les dernières mises à jour de la plateforme EVO; optimisation des outils, ajouts de fonctionnalités et nouveaux produits seront présentés en détails sous cette section.",
            modals: [
              {
                code: 'par_accueil_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_accueil_modal1.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [22.3, 19.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.4, 37.7, 97.3, 61],
            content: "<i>Créer une illustration</i> permet d’accéder aux familles de produits à illustrer. Une fois la famille sélectionnée, vous pouvez choisir une protection de base au centre de l’écran.",
            modals: []
          },
          {
            buttonPosition: [40, 19.2, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [36, 28.2, 12.8, 6.5],
            content: "<i>Mes dossiers</i> permet de consulter et modifier les illustrations sauvegardées, incluant les illustrations effectuées à partir de la Suite Interface.",
            modals: [
              {
                code: 'par_accueil_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_accueil_modal2.jpg') + '" style="max-width: 90%"></div><br>Vous pouvez rechercher une vente existante en inscrivant le nom du dossier, du contractant ou de l’assuré dans la barre de recherche. Notez que cette fonctionnalité s’applique également aux ventes en cours ou celles complétées.'
              }
            ]
          },
          {
            buttonPosition: [67.9, 17.5, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [59.1, 27.8, 21.2, 6.2],
            content: "Cliquez sur <i>Comparateur de primes maladie grave</i> afin d’afficher et de comparer sur un même écran les montants et les primes des polices d’assurance maladie grave. Il sera également possible d’y accéder en cours d’illustration dans le produit d’assurance maladie grave.",
            modals: [
              {
                code: 'par_accueil_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/comparateur_modale.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [86.9, 17.5, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [80.4, 27.8, 18.5, 6.2],
            content: "<i>Demander un changement</i> permet de demander la modification d’un contrat en vigueur : informations du client, ajout de protections, avenants, etc.",
            modals: []
          },
          {
            buttonPosition: [80.4, 37.9, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [81.3, 28.5, 3, 4.6],
            content: "Le cadenas indique qu’une connexion est requise pour accéder à la section.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 76, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [1.6, 77.1, 23.9, 20],
            content: "Sélectionner la famille <i>Concepts</i> pour illustrer certains produits admissibles en montrant comment ils peuvent aider vos clients à atteindre leurs objectifs financiers en plus de répondre à leur besoin d'assurance.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Interface générale',
        code: 'ass-par-interface-generale',
        image: require('../images/FR_PAR_interface-generale.jpg'),
        infos: [
          {
            buttonPosition: ['auto', -1.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [-0.6, -0.8, 101.3, 6.7],
            content: "À partir de cette page, vous pouvez en tout temps : <ul>" +
              "<li><img src='" + require('../images/icon-tool.jpg') + "'> Transférer le dossier à une tierce personne </li>" +
              "<li><img src='" + require('../images/label-connection.jpg') + "'> Établir une connexion sécurisée</li>" +
              "<li><img src='" + require('../images/icon-save.jpg') + "'> Enregistrer votre illustration et activer la sauvegarde automatique.</li>" +
              "<li><img src='" + require('../images/icon-suitcase.jpg') + "'> Exigences – Assurance vie / Assurance maladie grave.</li>" +
              "<li><img src='" + require('../images/icon-home.jpg') + "'> Retourner à l’écran d’accueil des familles de produits</li>" +
              "<li><img src='" + require('../images/icon-settings.jpg') + "'> Personnaliser votre profil et vos paramètres par défaut</li>" +
              "<li><img src='" + require('../images/icon-help.jpg') + "'> Obtenir de l’information sur le logiciel</li>" + "</ul>",
            modals: []
          },
          {
            buttonPosition: ['auto', 8.6, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.3, 5.5, 49.9, 5.6],
            content: "Cette section permet la création d’un nouveau scénario ou d’en dupliquer un afin d’illustrer des alternatives pour votre client ou des membres de sa famille, jusqu'à un maximum de cinq scénarios. Il est également possible de réinitialiser les scénarios.",
            modals: []
          },
          {
            buttonPosition: [47, 12.9, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [2, 12, 43, 4.8],
            content: "<b><u>Protections</u> : </b>permet d’afficher le type de protection sélectionnée, d’identifier les assurés et les contractants, de sélectionner des protections supplémentaires et des avenants et de simuler une prime en fonction des dépôts et des retraits projetés.<br><br>" +
              "<b><u>Concepts</u> : </b>permet d'activer et de paramétrer un concept de vente sur l'illustration en cours ou encore de le désactiver.<br><br>" +
              "<b><u>Résultats</u> : </b>permet de consulter les tableaux de résultats des projections du scénario en cours.<br><br>" +
              "<b><u>Rapports</u> : </b>permet de générer et d'imprimer le rapport d’illustration.",
            modals: []
          },
          {
            buttonPosition: ['auto', 45, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.6, 17.5, 78.2, 82],
            content: "Cette section permet d’entrer les informations de l’illustration rapidement afin d’obtenir une prime instantanément.",
            modals: []
          },
          {
            buttonPosition: [73.6, 90, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [79.3, 17.5, 20.2, 82],
            content: "<b><u>Au contrat</u> : </b>présente la prime versée pour le contrat de votre client.<br><br>" +
              "<b><u>Détails des protections</u> : </b>présente toutes les protections de tous les assurés du scénario en cours ainsi que les frais de police.<br><br>" +
              "<b><u>Passer à la proposition</u> : </b>si l’un des crochets est gris, vous devrez ajouter les informations manquantes pour passer à la proposition.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: 'Protections (Assurés et protections)',
        code: 'ass-par-ecran-principale-protection',
        image: require('../images/FR_PAR_protection-assures.jpg'),
        infos: [
          {
            buttonPosition: [59.7, 10.7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [1.4, 13, 55.6, 4.5],
            content: "Vous pouvez visualiser le type d'assurance à cet endroit, mais celui-ci n'est pas modifiable pour ce type de protection de base au contrat.",
            modals: []
          },
          {
            buttonPosition: [82, 23.1, 'auto'],
            popupPosition: ['left', 'center'],
            pointerPosition: [76.8, 18.1, 18.1, 3.5],
            content: "Ce lien cliquable permet de démontrer l’effet d’un statut préférentiel d’un des assurés.",
            modals: [
              {
                code: 'par_protection-assures_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_protection-assures_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 22.5, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 22.8, 14.6, 4.9],
            content: "Cliquez sur le crayon afin d’inscrire le nom et le prénom de l’assuré.",
            modals: [
              {
                code: 'par_protection-assures_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_PAR_protection-assures_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [102, 34.3, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [83.4, 35.8, 11.6, 3.5],
            content: "Ce lien cliquable permet d’ajouter une surprime sur une protection pour un assuré.",
            modals: [
              {
                code: 'par_protection-assures_modal4',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_PAR_protection-assures_modal4.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [64, 35.8, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [1.7, 41, 60.5, 4.4],
            content: "Sélectionner l’option d’affectation des participations qui convient le mieux à votre client. Les participations ne sont pas garanties, elles sont calculées annuellement et versées à l’anniversaire du contrat.",
            modals: []
          },
          {
            buttonPosition: ['auto', 41.8, 101],
            popupPosition: ['top', 'left'],
            pointerPosition: [2.5, 46.7, 95.4, 10.2],
            content: "Vous pouvez modifier la protection de base du scénario. Cette section présente les options supplémentaires disponibles en fonction de la protection de base sélectionnée.",
            modals: []
          },
          {
            buttonPosition: ['auto', 53.4, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [2.5, 51.7, 4.4, 5.1],
            content: "Cliquer sur l’icône document afin d’accéder au <i>Guide du produit</i>.",
            modals: []
          },
          {
            buttonPosition: [102, 49.8, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [61.2, 46.5, 30.9, 10.2],
            content: "Cliquer sur la touche <i>Prime</i> afin de déterminer le montant du capital assuré en fonction d’une prime donnée qui correspond au budget du client. Vous pourrez inscrire le montant de la prime et le capital assuré s’affichera automatiquement. Il est également possible de basculer vers la touche <i>Montant</i> et inscrire ensuite le montant d’assurance pour obtenir la prime. Vous pouvez illustrer des protections d’assurance qui excèdent les limites de certains produits, jusqu’à 90M$.",
            modals: []
          },
          {
            buttonPosition: [37.6, 60.5, 'auto'],
            popupPosition: ['right', 'center'],
            pointerPosition: [2, 57.6, 31, 4.1],
            content: "Cliquez sur <i>Ajouter une protection/avenant</i> pour ajouter une protection additionnelle ou une garantie.",
            modals: [
              {
                code: 'par_protection-assures_modal6',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_protection-assures_modal6.jpg') + '" style="max-width: 90%"></div><br>Ce panneau permet de faire les choix de protections supplémentaires selon les besoins de votre client.'
              }
            ]
          },
          {
            buttonPosition: [102, 76.1, 'auto'],
            popupPosition: ['top', 'right'],
            pointerPosition: [1.2, 67.8, 97.7, 30.2],
            content: "Vous pouvez ajouter un contractant supplémentaire ou le remplacer par une société. Cliquez sur le crayon pour le modifier au besoin.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Protections (Informations générales, Prime versée, Changement d'affectation des participations)",
        code: 'ass-par-ecran-principale-info',
        image: require('../images/FR_PAR_protection-info.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 9, 103],
            popupPosition: ['top', 'left'],
            pointerPosition: [3.1, 10.5, 82.8, 5.7],
            content: "Sélectionnez la province de résidence du contractant.",
            modals: []
          },
          {
            buttonPosition: [104, 17, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [3.1, 18.1, 65.7, 5.3],
            content: "Le taux d’imposition de la province sélectionnée est affiché par défaut : celui-ci peut être modifié. Cliquez sur <i>Autres taux</i> pour connaître les différents types de taux et gérer les taux relatifs aux sociétés.",
            modals: [
              {
                code: 'par_protection-info_modal1',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_protection-info_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 24.3, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 23.2, 81, 7.4],
            content: "Cliquez sur <i>Modifier</i> pour modifier la date d'effet du contrat. Pour en savoir plus sur la date d'effet, cliquez sur <i>Modifier</i> et ensuite sur le point d’interrogation dans le coin supérieur droit.",
            modals: [
              {
                code: 'par_protection-info_modal3',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_PAR_protection-info_modal3.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: ['auto', 41.9, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 39.7, 93.2, 8.5],
            content: "Choisissiez la fréquence du paiement de la prime. La sélection affectera les montants affichés dans le sommaire.",
            modals: []
          },
          {
            buttonPosition: [84.6, 53.7, 'auto'],
            popupPosition: ['bottom', 'right'],
            pointerPosition: [3.1, 53.2, 79.2, 8],
            content: "Cocher la case <i>Option de dépôt supplémentaire</i> si votre client souhaite effectuer une contribution lui permettant de souscrire de l’assurance libérée additionnelle et par conséquent, bénéficier d’un capital-décès et d’une valeur de rachat plus élevés.",
            modals: []
          },
          {
            buttonPosition: ['auto', 65.6, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 64.8, 40.4, 8],
            content: "Cocher la case <i>Éclipse de prime</i> afin de prévoir un moment à partir duquel le client pourra cesser le paiement de la prime grâce aux participations annuelles. La fonctionnalité permet également d’indiquer le moment le plus tôt à partir duquel il pourra se prévaloir de l’Éclipse de prime. Référez-vous au <i>Guide du produit</i> pour en savoir plus.",
            modals: []
          },
          {
            buttonPosition: ['auto', 89.1, 103],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [3.1, 87.1, 91.4, 11.5],
            content: "Cocher la case <i>Option Bonifications d’assurance libérée vers Payable au comptant</i> afin de prévoir un moment à partir duquel le client recevra les participations annuelles au comptant.Vous pourrez alors choisir d’illustrer le moment le plus tôt où ce changement est disponible ou encore une année subséquente de votre choix.",
            modals: []
          }
        ],
        modals: []
      },
      {
        title: "Concepts",
        code: 'ass-par-ecran-concepts',
        image: require('../images/FR_PAR_concepts.jpg'),
        infos: [
          {
            buttonPosition: [29.5, 21.1, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 21.8, 27.1, 5.0],
            content: "La liste déroulante permet de sélectionner le concept à présenter.",
            modals: []
          },
          {
            buttonPosition: [-6.6, 29.1, 'auto'],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.5, 28.1, 54, 35.8],
            content: "Vous pouvez modifier les différents paramètres qui seront appliqués au concept.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Résultats",
        code: 'ass-par-ecran-principale-resultats',
        image: require('../images/FR_PAR_resultats.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 20.5, 101],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [0.5, 21.4, 22.1, 3.6],
            content: "La liste déroulante permet de sélectionner le type de tableau à présenter.",
            modals: []
          },
          {
            buttonPosition: [35.4, 20.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [23.8, 21.4, 10, 3.7],
            content: "Cliquez sur ce lien pour voir la liste des assurés du scénario.",
            modals: [
              {
                code: 'par_resultats_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_TR_resultats_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },
          {
            buttonPosition: [57.9, 17.9, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [64.1, 17.3, 14.8, 7],
            content: "Cliquez sur ce bouton pour exporter le tableau de résultats dans un document Excel.",
            modals: []
          },
        ],
        modals: []
      },
      {
        title: "Rapports",
        code: 'ass-par-ecran-principale-rapports',
        image: require('../images/FR_PAR_rapports.jpg'),
        infos: [
          {
            buttonPosition: ['auto', 45, 100],
            popupPosition: ['top', 'left'],
            pointerPosition: [0.7, 34, 49.6, 38.5],
            content: "Sélectionnez les informations que vous souhaitez inclure dans votre rapport.",
            modals: []
          },
          {
            buttonPosition: [66, 86.2, 'auto'],
            popupPosition: ['bottom', 'center'],
            pointerPosition: [50.6, 88, 14.4, 3.7],
            content: "Ajoutez le nom du conseiller afin de personnaliser le rapport.",
            modals: [
              {
                code: 'par_rapports_modal2',
                content: '<div class="ui container center aligned"><img src="' + require('../images/FR_VU_rapports_modal2.jpg') + '" style="max-width: 90%"></div>'
              }
            ]
          },

          {
            buttonPosition: [45, 27, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [50.6, 29.2, 14, 3.7],
            content: "Sélectionnez la langue dans laquelle vous souhaitez générer le rapport.",
            modals: []
          },
          {
            buttonPosition: [58.1, 15.5, 'auto'],
            popupPosition: ['bottom', 'left'],
            pointerPosition: [63.6, 16.8, 15.6, 7.6],
            content: "Générez le rapport personnalisé en format PDF en cliquant sur ce bouton.",
            modals: []
          },
        ],
        modals: []
      }
    ]
  },
];

export { texts, demoTexts };
